import {
  ContentAlignment,
  FullWidthTextComponent,
  VxlText,
} from '@varo/graphql-schema-types';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Text, TextStyle } from 'react-native';
import { getVXLAlignment } from 'shared/utils/getVXLAlignment/getVXLAlignment';
import { getVXLColor } from 'shared/utils/getVXLColor/getVXLColor';
import { getVXLFont } from 'shared/utils/getVXLFont/getVXLFont';

export const FullWidthTextComponentView = (element: FullWidthTextComponent) => {
  return <VXLTextView {...element} />;
};

export interface VXLTextViewProps {
  id: string;
  text: VxlText;
  textAlignment?: ContentAlignment;
}

export const TextAlignment: Record<ContentAlignment, TextStyle['textAlign']> = {
  [ContentAlignment.Leading]: 'left',
  [ContentAlignment.Trailing]: 'right',
  [ContentAlignment.Center]: 'center',
};

export const VXLTextView = (element: VXLTextViewProps) => {
  const vxlFont = getVXLFont(element.text.style.fontStyle);
  const vxlColor = getVXLColor(element.text.style.color);
  const vxlAlignment = getVXLAlignment(
    element.textAlignment ?? ContentAlignment.Leading,
  );

  return (
    <Text
      style={{
        ...(vxlFont as TextStyle),
        alignContent: vxlAlignment,
        textAlign:
          TextAlignment[element.textAlignment ?? ContentAlignment.Leading],
        color: vxlColor,
      }}
      key={element.id}
    >
      {element.text.copy}
    </Text>
  );
};
